/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, Fragment, useEffect, useState } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { EnableSidebar } from '../../../../_metronic/layout/core'
import { checkResetUser, updatePassword } from '../../auth/core/_requests'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useFormik } from 'formik'
import Swal from 'sweetalert2'
import { AxiosError } from 'axios'
import { PasswordMeterComponent } from '../../../../_metronic/assets/ts/components'

const initialValues = {
    password: '',
    changepassword: ''
}

const registrationSchema = Yup.object().shape({
    password: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required'),
    changepassword: Yup.string()
        .required('Password confirmation is required')
        .when('password', {
            is: (val: string) => (val && val.length > 0 ? true : false),
            then: Yup.string().oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
        })
})

function getError() {
    return <div className="alert alert-warning d-flex align-items-center p-5 mb-10 w-100">
        <span className="bi bi-exclamation-triangle fs-3x me-3"></span>

        <div className="d-flex flex-column">
            <h5 className="mb-1">เกิดข้อผิดพลาด</h5>
            <span className='text-gray-800'>รหัสในการตั้งรหัสผ่านผู้ใช้งานไม่ถูกต้อง กรุณาตรวจสอบลิงค์ใหม่</span>
        </div>
    </div>
}

function getDone() {
    return <div className="alert alert-success d-flex align-items-center p-5 mb-10 w-100">
        <span className="bi bi-shield-fill-check fs-3x me-3"></span>

        <div className="d-flex flex-column">
            <h5 className="mb-1">อัพเดทรหัสผ่านเรียบร้อย</h5>
            <span className='text-gray-800'>กรุณา login เพื่อเข้าใช้งานระบบ</span>
        </div>
    </div>
}

type Props = {
    encoded_user_id: string | null, setLoading: Function, loading: boolean, setComponentStatus: Function
}

const ResetComponent = ({ encoded_user_id, setLoading, loading, setComponentStatus }: Props) => {
    const formik = useFormik({
        initialValues,
        validationSchema: registrationSchema,
        onSubmit: async (values, { setStatus, setSubmitting, resetForm }) => {
            setLoading(true)
            try {
                await updatePassword(
                    encoded_user_id,
                    values.password
                )

                setComponentStatus('done')
                setSubmitting(false)
                setLoading(false)

                Swal.fire({
                    title: 'Success!',
                    text: 'ระบบได้ทำการอัพเดทรหัสผ่านใหม่เรียบร้อย',
                    icon: 'success'
                })

            } catch (e) {
                const err = e as AxiosError
                const error_data = err.response?.data
                const error_msg = error_data.msg ?? 'ไม่สามารถตั้งค่ารหัสผ่านใหม่ได้'

                Swal.fire({
                    title: 'เกิดข้อผิดพลาด!',
                    text: error_msg,
                    icon: 'warning'
                })

                setComponentStatus('error')
                setSubmitting(false)
                setLoading(false)
            }
        },
    })

    useEffect(() => {
        PasswordMeterComponent.bootstrap()
    }, [])

    return <form className='form w-800px fv-plugins-bootstrap5 fv-plugins-framework' noValidate
        id='kt_login_signup_form'
        onSubmit={formik.handleSubmit}
    >
        {/* begin::Heading */}
        <div className='mb-10 text-center'>
            <div className='d-flex flex-stack flex-wrap bg-light-primary ps-2 pt-2'>
                <div className='d-flex align-items-center py-1'>
                    <div className='symbol symbol-35px me-2'>
                        <img
                            alt='key'
                            src={toAbsoluteUrl('/media/custom/key.png')}
                            className='d-none d-lg-inline w-55px theme-light-show'
                        />
                    </div>

                    <div className='d-flex flex-column align-items-start justify-content-center'>
                        <h1 className='fs-2x fw-bolder text-gray-900 mb-0 me-1'>
                            ตั้งค่ารหัสผ่านใหม่
                        </h1>
                        <h2 className='text-dark mb-3'>กรุณาระบุรหัสผ่านใหม่ที่คุณต้องการ</h2>
                    </div>
                </div>
            </div>


        </div>

        {formik.status && (
            <div className='mb-lg-15 alert alert-danger'>
                <div className='alert-text font-weight-bold'>{formik.status}</div>
            </div>
        )}

        {/* begin::Form group Password */}
        <div className='mb-10 fv-row' data-kt-password-meter='true'>
            <div className='mb-1'>
                <label className='form-label fw-bolder text-dark fs-6'>รหัสผ่าน</label>
                <div className='position-relative mb-3'>
                    <input
                        type='password'
                        placeholder='Password'
                        autoComplete='off'
                        {...formik.getFieldProps('password')}
                        className={clsx(
                            'form-control form-control-lg form-control-solid',
                            {
                                'is-invalid': formik.touched.password && formik.errors.password,
                            },
                            {
                                'is-valid': formik.touched.password && !formik.errors.password,
                            }
                        )}
                    />
                    {formik.touched.password && formik.errors.password && (
                        <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                                <span role='alert'>{formik.errors.password}</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group Confirm password */}
        <div className='fv-row mb-5'>
            <label className='form-label fw-bolder text-dark fs-6'>ยืนยันรหัสผ่าน</label>
            <input
                type='password'
                placeholder='Password confirmation'
                autoComplete='off'
                {...formik.getFieldProps('changepassword')}
                className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                        'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
                    },
                    {
                        'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
                    }
                )}
            />
            {formik.touched.changepassword && formik.errors.changepassword && (
                <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.changepassword}</span>
                    </div>
                </div>
            )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='text-center'>
            <button
                type='submit'
                id='kt_sign_up_submit'
                className='btn btn-lg btn-primary w-100 mb-5'
                disabled={formik.isSubmitting || !formik.isValid}
            >
                {!loading && <span className='indicator-label'>บันทึก</span>}
                {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                )}
            </button>
        </div>
        {/* end::Form group */}
    </form>
}

const ResetPassword: React.FC = () => {
    const [textFormatting, setTextFormatting] = useState<boolean>(false)
    const [searchParams, setSearchParams] = useSearchParams();
    let encoded_user_id = searchParams.get("reset")
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState('');

    useEffect(() => {
        // React advises to declare the async function directly inside useEffect
        async function updateStatus() {
            try {
                await checkResetUser(encoded_user_id)
                setStatus('user_exist')
                setLoading(false)
            } catch (error) {
                console.error(error)
                setStatus('error')
                setLoading(false)
            }
        };

        if (loading && status != "success") {
            updateStatus()
        }
    }, []);

    return (
        <>
            <div className='mb-0'>
                <div className='d-flex flex-stack flex-wrap mt-2'>
                    <div className='d-flex align-items-center py-1 w-100'>
                        {loading && <h3>
                            <span className="spinner-border spinner-border-sm align-middle me-2"></span>
                            กำลังตรวจสอบ...
                        </h3>}

                        {!loading && status == "error" && getError()}
                        {!loading && status == "user_exist" &&
                            <div className='d-flex align-middle align-items-center justify-content-center w-100'>
                                <ResetComponent setComponentStatus={setStatus} encoded_user_id={encoded_user_id} setLoading={setLoading} loading={loading} />
                            </div>
                        }
                        {!loading && status == "done" && getDone()}
                    </div>

                </div>
            </div>

            <div className='separator separator-dashed border-gray-300 mt-8 mb-10'></div>

        </>
    )
}

export { ResetPassword }
